import { createAction } from 'redux-actions';
import { actionKey } from './constants';
export const initialize = createAction(`${actionKey}.INIT`, (config)=>({
        config
    }));

//# sourceMappingURL=actions.js.map